<template>
  <list-container :list="orders">
    <template v-slot:not-found>
      <v-row class="py-8" justify="center" align="center" no-gutters>
        <v-col cols="10">
          <v-icon size="150" color="grey" v-if="$vuetify.breakpoint.mdAndUp">history</v-icon>
          <v-icon class="mb-2" size="100" color="grey" v-else>history</v-icon>
          <div class="headline font-weight-regular mb-xl-5 mb-lg-5 mb-md-5 mb-sm-4 mb-4 not-found-title">No se encontraron pedidos.</div>
          <div class="mb-xl-1 mb-lg-1 mb-md-1">
            <v-btn class="text-none" color="blue darken-" dark large outlined @click="goToRouteByName('Home')">
              <v-icon left>store</v-icon>Continuar comprando
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-slot:items>
      <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pt-sm-0 pt-0 px-xl-4 px-lg-4 px-md-4 px-sm-0 px-0 pb-xl-6 pb-lg-6 pb-md-6 pb-sm-2 pb-1" no-gutters v-if="drawItems">
        <v-col class="pl-5" xl="8" lg="9" md="11" sm="12" cols="12" v-if="$vuetify.breakpoint.mdAndUp">
          <div class="mb-4 pr-1 text-right grey--text text--darken-2">
            Historial de Pedidos
          </div>
        </v-col>
        <v-col class="toolbar-quantity" v-else>
          <v-toolbar dense>
            <v-toolbar-title class="subtitle-2 grey--text">
              Historial de Pedidos
            </v-toolbar-title>
          </v-toolbar>
        </v-col>
        <v-col xl="8" lg="9" md="11" sm="12" cols="12" :class="$vuetify.breakpoint.mdAndUp ? 'card-border-bottom':  ''">
          <v-card class="mx-auto text-left pb-1 card-border-left card-border-right" v-for="(order, index) in orders.orders" :key="order.order_id" tile flat>
            <v-row no-gutters class="card-border-top">
              <v-col class="center-col" xl="2" lg="2" md="2" sm="2" cols="3">
                <v-icon size="60" color="blue" v-if="$vuetify.breakpoint.mdAndUp">shopping_cart</v-icon>
                <v-icon size="50" color="blue" v-if="$vuetify.breakpoint.smAndDown">shopping_cart</v-icon>
              </v-col>
              <v-col xl="9" lg="9" md="9" sm="9" cols="7" class="px-xl-2 px-lg-2 px-md-2 px-sm-2 px-3 pt-xl-2 pt-lg-2 pt-md-2 pt-sm-1 pt-2 mb-4">
                <div class="text--primary text-left font-weight-light text-lowercase pruchase-title first-capital-letter mt-2">
                  <span v-if="isDeliveryStatusPending(index)">
                    Comprado el {{ dateFormat(order.creation_date, 'D MMM YYYY') }}
                  </span>
                  <span :class="'shipment-' + getOrdersDeliveryLastRecord(index).status" v-else>
                    {{ getDeliveryStatusTitle(getOrdersDeliveryLastRecord(index).status) }} el {{ dateFormat(getOrdersDeliveryLastRecord(index).creation_date, 'D MMM YYYY') }}
                  </span>
                </div>
                <div class="title label-price text-left font-weight-medium">{{ getOrdersCost(index) }}</div>
                <div class="text-left pruchase-subtitle body-2 grey--text">
                  Enviar a {{ order.address.city.name }}, {{ order.address.region.name }}
                </div>
                <div :class="'text-left pruchase-subtitle mt-xl-1 mt-lg-1 mt-md-1 mt-sm-1 mt-1 payment-' + order.payment.status">{{ getPaymentStatus(order.payment.status) }}</div>
              </v-col>
              <v-col class="center-col pt-xl-5 pt-lg-5 pt-md-5 pt-sm-4 pt-3" xl="1" lg="1" md="1" sm="1" cols="2" align-self="start">
                <v-menu bottom>
                  <template v-slot:activator="{ on }">
                      <v-icon v-on="on">mdi-dots-vertical</v-icon>
                  </template>
                  <v-list class="text-left" dense>
                    <v-list-item @click="goToRouteByName('Order', {id: order.order_id })">
                      <v-list-item-icon class="mr-4">
                        <v-icon color="#606060">visibility</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Detalle</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="retry(order)" v-if="statusCanRetryPayment(order.payment.status)">
                      <v-list-item-icon class="mr-4">
                        <v-icon color="#606060">payment</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Reintentar pago</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="goToRouteByName('Shipment', {id: order.order_id })">
                      <v-list-item-icon class="mr-4">
                        <v-icon color="#606060">local_shipping</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Segir envío</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="progress-container card-border-left card-border-right card-border-top" tile flat v-if="orders.next">
            <v-progress-circular class="progress" indeterminate size="24" width="3" v-if="loading"></v-progress-circular>
            <v-btn text class="text-none load-more" small @click="getMoreOrders(orders.next)" v-else>Cargar Mas</v-btn>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </list-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import ListContainer from '@/components/List/ListContainer'
import { dateFormat } from '@/shared/format'
import { getPaymentStatus, statusCanRetryPayment } from '@/shared/payment'
import { DELIVERY_STATUS_PENDING, getDeliveryStatusTitle } from '@/shared/delivery'

export default {
  mixins: [navigationMixin],
  components: {
    ListContainer
  },
  data () {
    return {
      dateFormat,
      getPaymentStatus,
      statusCanRetryPayment,
      getDeliveryStatusTitle
    }
  },
  computed: {
    ...mapState('shared', ['loading']),
    ...mapState('order', ['orders']),
    ...mapGetters('order', ['getOrdersCost', 'getOrdersDeliveryLastRecord']),
    drawItems () {
      return this.orders && this.orders.orders
    }
  },
  methods: {
    ...mapActions('order', ['getOrders', 'getMoreOrders']),
    isDeliveryStatusPending (index) {
      const record = this.getOrdersDeliveryLastRecord(index)

      return record === null || record.status === DELIVERY_STATUS_PENDING
    },
    retry (order) {
      window.location.href = order.payment_url
    }
  },
  mounted () {
    this.getOrders()
  }
}
</script>

<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';
  .toolbar-quantity{
    margin-bottom: 0.5px;
  }
  .pruchase-title{
    font-size: 1.25em;
  }
  .center-col{
    display: flex;
    justify-content: center;
  }
  .progress-container {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .progress {
    color: #1E88E5;
  }
  .shipment-delivered {
    color: #388E3C;
    font-weight: 400;
  }
  .shipment-returned {
    color: #F57C00;
    font-weight: 400;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .pruchase-title{
      font-size: 15px;
      line-height: 18px;
    }
    .label-price{
      font-size: 16px !important;
    }
    .pruchase-subtitle{
      font-size: 13px !important;
      line-height: 16px;
    }
    .not-found-title{
      font-size: 16px !important;
      line-height: 24px;
    }
  }
</style>
